import axios from "axios";
import Swal from "sweetalert2";
import router from "@/router/";

const baseUrl = process.env.VUE_APP_API_URL_V1;

const main = {
  state: {
    loading: false,
    stepperActive: 0,
    form: {
      jeniskendaraan: "",
      nik: "",
      no_pol: "",
      no_rangka: "",
      no_hp: "",
      tindak_selaku: "",
      alasan: "",
      laporjualname: "",
      laporjualaddress: "",
      fileKTP: "",
      fileFotoKendaraan: "",
      fileKK: "",
      fileBukti: "",
      fileDigitalSign: "",
    },
    infoKendaraan: "",
    reports: [],
    report: {},
  },
  mutations: {
    SET_LOADING_MAIN(state, payload) {
      state.loading = payload;
    },
    SET_STEPPER_ACTIVE(state, payload) {
      state.stepperActive = payload;
    },
    SET_FORM_MAIN(state, payload) {
      state.form[payload.key] = payload.value;
    },
    RESET_FORM_MAIN(state) {
      (state.form = {
        jeniskendaraan: "",
        nik: "",
        no_pol: "",
        no_rangka: "",
        no_hp: "",
        tindak_selaku: "",
        alasan: "",
        laporjualname: "",
        laporjualaddress: "",
        fileKTP: "",
        fileFotoKendaraan: "",
        fileKK: "",
        fileBukti: "",
        fileDigitalSign: "",
      }),
        (state.infoKendaraan = "");
    },
    SET_INFO_KENDARAAN(state, payload) {
      state.infoKendaraan = payload;
    },
    SET_REPORTS_MAIN(state, payload) {
      state.reports = payload;
    },
    SET_REPORT_MAIN(state, payload) {
      state.report = payload;
    },
  },
  actions: {
    async InformationPajakKendaraanBermotor(context) {
      try {
        context.commit("SET_LOADING_MAIN", true);

        const result = await axios({
          url: `${baseUrl}/LaporJual/InformationPajakKendaraanBermotor?nopol=${context.state.form.no_pol}&norangka=${context.state.form.no_rangka}`,
          method: "GET",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (result.data.nopol === null) {
          Swal.fire("Gagal!", "Nopol tidak ditemukan", "error");
          return;
        }

        context.commit("SET_INFO_KENDARAAN", result.data);
        context.commit("SET_STEPPER_ACTIVE", 1);
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error.message,
          icon: "error",
        });
        console.log(error);
      } finally {
        context.commit("SET_LOADING_MAIN", false);
      }
    },
    async VehicleList(context) {
      try {
        context.commit("SET_LOADING_MAIN", true);

        const result = await axios({
          url: `${baseUrl}/LaporJual/VehicleList`,
          method: "GET",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        context.commit("SET_REPORTS_MAIN", result.data);
      } catch (error) {
        console.log(error);
      } finally {
        context.commit("SET_LOADING_MAIN", false);
      }
    },
    async DetailVehicle(context, id) {
      try {
        context.commit("SET_LOADING_MAIN", true);

        const result = await axios({
          url: `${baseUrl}/LaporJual/DetailVehicle/${id}`,
          method: "GET",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        context.commit("SET_REPORT_MAIN", result.data);
      } catch (error) {
        console.log(error);
      } finally {
        context.commit("SET_LOADING_MAIN", false);
      }
    },
    async AddVehicle(context) {
      try {
        context.commit("SET_LOADING_MAIN", true);

        const data = new FormData();
        let model = {
          jeniskendaraan: context.state.form.jeniskendaraan,
          nik: context.state.form.nik,
          no_pol: context.state.form.no_pol,
          no_rangka: context.state.form.no_rangka,
          no_hp: context.state.form.no_hp,
          tindak_selaku: context.state.form.tindak_selaku,
          alasan: context.state.form.alasan,
          laporjualname: context.state.form.laporjualname,
          laporjualaddress: context.state.form.laporjualaddress,
          base64sign: context.state.form.fileDigitalSign,
        };
        data.append("model", JSON.stringify(model));
        data.append("fileKTP", context.state.form.fileKTP);
        data.append("fileFotoKendaraan", context.state.form.fileFotoKendaraan);
        data.append("fileKK", context.state.form.fileKK);
        data.append("fileBukti", context.state.form.fileBukti);
        // data.append("fileDigitalSign", context.state.form.fileDigitalSign);

        console.log(data);
        await axios({
          url: `${baseUrl}/LaporJual/AddVehicle`,
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
          data: data,
        });

        context.commit("SET_STEPPER_ACTIVE", 0);
        context.commit("RESET_FORM_MAIN");

        Swal.fire({
          title: "Success",
          text: "Data berhasil ditambahkan dan Wajib Pajak segera melakukan pemblokiran di Samsat Lantai 3 ruangan  Regident",
          icon: "success",
        });
        router.push("/history");
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: JSON.parse(error.request.response).head,
          text: JSON.parse(error.request.response).text,
          icon: "error",
        });
        if (error.response.status === 409) {
          context.commit("SET_STEPPER_ACTIVE", 0);
          context.commit("RESET_FORM_MAIN");
          router.push("/history");
        }
      } finally {
        context.commit("SET_LOADING_MAIN", false);
      }
    },
  },
};

export default main;
